import { formatSingleItemFeedToBE } from './formatSingleItemFeedToBE'

import { FB_PAGE_CHOICE, INSTA_ACCOUNT_CHOICE, INSTAGRAM_ACTOR_ID } from '../../../../../../fields'
import { MEDIA_TYPE } from '../../../../../../../../Google/AdForms/fields'
import { IMAGE_HASH } from '../../../../../../../../ReusableFormFields/AdFileUpload/fields'

import { FormatSingleItemToBEParams, FormattedSingleItem } from './types'

export const formatSingleItemToBE = ({ values, tags, lineItem }: FormatSingleItemToBEParams): FormattedSingleItem => {
  const {
    [INSTA_ACCOUNT_CHOICE]: instagramAccountChoice,
    [FB_PAGE_CHOICE]: facebookPageChoice,
    [MEDIA_TYPE]: mediaType,
    [IMAGE_HASH]: fileHash
  } = values

  const objectStorySpec = {
    // page_id and instagram_user_id should be added in 2 places, do not remove any of them
    page_id: facebookPageChoice,
    ...(instagramAccountChoice && { [INSTAGRAM_ACTOR_ID]: instagramAccountChoice }),
    ...formatSingleItemFeedToBE(values, lineItem),

    // in case lineItem objective is 'page_likes', we need to add call_to_action with page on this level
    ...(lineItem?.objective === 'page_likes' &&
      lineItem?.promoted_object?.page_id && {
        call_to_action: {
          type: 'LIKE_PAGE',
          value: {
            page: lineItem.promoted_object.page_id
          }
        }
      })
  }

  return {
    // page_id and instagram_user_id should be added in 2 places, do not remove any of them
    actor_id: facebookPageChoice,
    ...(instagramAccountChoice && { [INSTAGRAM_ACTOR_ID]: instagramAccountChoice }),
    ...(tags && { url_tags: tags }),
    image_hash: mediaType === 'image' ? fileHash : undefined,
    object_story_spec: objectStorySpec
  }
}
